/**
 * QueryString基础模块
 * 支持：
 * 1.解析url中的query-string，parse函数
 * 2.格式化query对象
 * 3.数组解析和格式化
 * @author luoying<luoying@szzbmy.com>
 * @since 17/06/03
 */
import { isObject, isString } from './check-types';
/**
 * 解析query-string
 * 支持多个同名key的解析，解析为数组
 * 解析后的value是经过decode的
 * @param  {string} str       query字符串
 * @param  {string} [sep='&'] 参数组分隔符，默认是&
 * @param  {string} [eq='=']  key-value分隔符，默认是=
 * @return {Query} 返回解析后的query对象
 */
export function parse(str, sep = '&', eq = '=') {
    const obj = {};
    if (!str || !isString(str))
        return obj;
    // 剥除url上的search之前部分
    str = str.replace(/.*?\?/, '');
    const groups = str.split(sep);
    for (const group of groups) {
        const eqIndex = group.indexOf(eq);
        // only key
        if (eqIndex === -1) {
            const key = decodeURIComponent(group);
            obj[key] = '';
            continue;
        }
        const key = decodeURIComponent(group.slice(0, eqIndex));
        const value = decodeURIComponent(group.slice(eqIndex + 1));
        // array
        if (obj[key] !== void 0) {
            const item = obj[key];
            if (!Array.isArray(item)) {
                obj[key] = [item, value];
            }
            else {
                item.push(value);
            }
            continue;
        }
        obj[key] = value;
    }
    return obj;
}
/**
 * 格式化query对象
 * 支持数组的格式化，格式化为同名key
 * 格式化后的query-string是经过encode的
 * @param  {QueryInput | null} [obj] query对象
 * @param  {string} [sep='&'] 参数组分隔符，默认是&
 * @param  {string} [eq='=']  key-value分隔符，默认是=
 * @return {string}           返回格式化后的query-string
 */
export function stringify(obj, sep = '&', eq = '=') {
    if (obj == null || !isObject(obj))
        return '';
    const qs = [];
    const keys = Object.keys(obj);
    for (const key of keys) {
        const value = obj[key];
        const encodedKey = encodeURIComponent(key);
        if (value == null) {
            qs.push([encodedKey, ''].join(eq));
            continue;
        }
        // array
        if (Array.isArray(value)) {
            const ks = value.map(val => {
                return [encodedKey, encodeURIComponent(val)].join(eq);
            });
            qs.push(...ks);
            continue;
        }
        qs.push([encodedKey, encodeURIComponent(value)].join(eq));
    }
    return qs.join(sep);
}
//# sourceMappingURL=query-string.js.map